import { TeamReview } from '@/app/libs/match/types'
import ThemeTable from '@/shared/components/themeTable'

export default function Review({
  battingReviewData,
  bowlingReviewData,
  reviewTable1Label,
  reviewTable2Label
}: {
  battingReviewData: TeamReview
  bowlingReviewData: TeamReview
  reviewTable1Label: (string | JSX.Element)[]
  reviewTable2Label: (string | JSX.Element)[]
}) {
  return (
    <>
      <p className="text-lg font-bold text-textOffWhite mb-3">Reviews</p>
      <div className="grid grid-cols-2 gap-4">
        <ThemeTable
          labels={reviewTable1Label}
          thClass="!py-2.5"
          className="!rounded-none md:!rounded-xl col-span-1"
          isBordered
        >
          {battingReviewData.sBattingTeamTotalReview ? (
            <tr>
              <td className="w-full py-3">Total Reviews</td>
              <td className="py-3">{battingReviewData?.sBattingTeamTotalReview}</td>
            </tr>
          ) : null}
          {battingReviewData.sBattingTeamReviewAvailable ? (
            <tr>
              <td className="w-full py-3">Reviews Left</td>
              <td className="py-3 !text-[#D59546]">
                {battingReviewData.sBattingTeamReviewAvailable}
              </td>
            </tr>
          ) : null}
          {battingReviewData.sBattingTeamReviewSuccess ? (
            <tr>
              <td className="w-full py-3">Review Success</td>
              <td className="py-3 !text-[#6CB240]">
                {battingReviewData.sBattingTeamReviewSuccess}
              </td>
            </tr>
          ) : null}
          {battingReviewData.sBattingTeamReviewFailed ? (
            <tr>
              <td className="w-full py-3">Review Fail</td>
              <td className="py-3 !text-[#D54664]">{battingReviewData.sBattingTeamReviewFailed}</td>
            </tr>
          ) : null}
          {battingReviewData.sBattingTeamReviewRetained ? (
            <tr>
              <td className="w-full py-3">Review Retained</td>
              <td className="py-3 !text-[#84afdc]">
                {battingReviewData.sBattingTeamReviewRetained}
              </td>
            </tr>
          ) : null}
        </ThemeTable>
        <ThemeTable
          labels={reviewTable2Label}
          thClass="!py-2.5"
          className="!rounded-none md:!rounded-xl col-span-1 h-fit"
          isBordered
        >
          {bowlingReviewData.sBowlingTeamTotalReview ? (
            <tr>
              <td className="w-full py-3">Total Reviews</td>
              <td className="py-3">{bowlingReviewData?.sBowlingTeamTotalReview}</td>
            </tr>
          ) : null}
          {bowlingReviewData.sBowlingTeamReviewAvailable ? (
            <tr>
              <td className="w-full py-3">Reviews Left</td>
              <td className="py-3 !text-[#D59546]">
                {bowlingReviewData.sBowlingTeamReviewAvailable}
              </td>
            </tr>
          ) : null}
          {bowlingReviewData.sBowlingTeamReviewSuccess ? (
            <tr>
              <td className="w-full py-3">Review Success</td>
              <td className="py-3 !text-[#6CB240]">
                {bowlingReviewData.sBowlingTeamReviewSuccess}
              </td>
            </tr>
          ) : null}
          {bowlingReviewData.sBowlingTeamReviewFailed ? (
            <tr>
              <td className="w-full py-3">Review Fail</td>
              <td className="py-3 !text-[#D54664]">{bowlingReviewData.sBowlingTeamReviewFailed}</td>
            </tr>
          ) : null}
          {bowlingReviewData.sBowlingTeamReviewRetained ? (
            <tr>
              <td className="w-full py-3">Review Retained</td>
              <td className="py-3 !text-[#84afdc]">
                {bowlingReviewData.sBowlingTeamReviewRetained}
              </td>
            </tr>
          ) : null}
        </ThemeTable>
      </div>
    </>
  )
}
